<template>
  <figure :is="tag" :to="to" :class="[baseCss, block ? 'block' : 'inline-block', `shadow-${elevation}`, setBgColor(), setTextColor(), tile ? 'bcq-avatar-tile' : null]" :style="styles()" role="img" @click="$emit('click')">
    <icon :name="icon" v-if="icon" :size="iconSize" :color="color" :color-lightness="colorLightness" />
    <div v-else-if="text" v-html="text" :class="[`text-${fontSize}`, 'font-bold']" :style="styles()" />
    <div v-else-if="src" v-html="text" :class="['bcq-avatar-src']" :style="styles(src)" />
  </figure>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'

export default {
  name: 'Avatar',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('avatar', ['select-none', 'outline-none', 'overflow-hidden', 'align-middle', 'uppercase', 'text-center', 'transition-all', 'duration-300'])
    }
  },
  props: {
    tag: {
      type: String,
      default: 'figure'
    },
    icon: {
      type: String
    },
    iconSize: {
      type: Number
    },
    block: {
      type: Boolean
    },
    size: {
      type: String,
      default: '32px'
    },
    to: {
      type: String
    },
    tile: {
      type: Boolean
    },
    src: {
      type: String
    },
    text: {
      type: [String, Number]
    },
    bgColor: {
      type: String,
      default: 'gray'
    },
    color: {
      type: String,
      default: 'white'
    },
    fontSize: {
      type: String,
      default: 'xs',
      validator: value => {
        return ['xs', 'md', 'sm', 'base', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', '7xl', '8xl', '9xl'].includes(value)
      }
    }
  },
  methods: {
    styles (src) {
      const size = this.size
      return {
        width: size,
        lineHeight: size,
        backgroundImage: src ? `url("${src}")` : null
      }
    }
  }
}
</script>
<style>
.bcq-avatar:not(.bcq-avatar-tile)
{
  border-radius: 100%;
}

.bcq-avatar .bcq-avatar-src
{
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.bcq-avatar,
.bcq-avatar *
{
  aspect-ratio: 1/1;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/avatar/avatar.vue